// factory function, not to be confused with batws.js which is not (see module.fad.js)
define('lib/services/lscs',['lib/rest'], function(RestAPI) {
  var spec = {
    host: '/contentservices/v1',
    apis: {
      'dcr': {
        url: '/document/path/',
        calls: {
          fetch: {
            url: '{raw!path}?project={tda:WWW}',
            contentType: 'application/xml'
          }
        }
      }
    }
  };

  return new RestAPI(spec);
});

